import { Chip } from '@mui/material';
import { colors } from 'Constants/Colors';
import { COURSE_STATUS_APPROVED, COURSE_STATUS_PENDING, COURSE_STATUS_REJECTED } from 'Constants/General';

interface CourseStatusChipProps {
  statusId: string;
  status: string;
}

const getStatusColor = (statusId: string) => {
  switch (statusId) {
    case COURSE_STATUS_APPROVED:
      return colors.GREEN;
    case COURSE_STATUS_PENDING:
      return colors.YELLOW;
    case COURSE_STATUS_REJECTED:
      return colors.RED;
    default:
      return colors.GRAY;
  }
};

const CourseStatusChip = ({ statusId, status }: CourseStatusChipProps) => {
  return (
    <Chip
      label={status}
      sx={{
        backgroundColor: getStatusColor(statusId),
        color: statusId === COURSE_STATUS_PENDING ? 'black' : 'white',
        fontWeight: 'bold',
      }}
    />
  );
};

export default CourseStatusChip;
